export const REQUEST_LOADING = "PAGE_REQUEST_LOADING";
export const REQUEST_SUCCESS = "PAGE_REQUEST_SUCCESS";
export const REQUEST_FAILED = "PAGE_REQUEST_FAILED";

export const LOADING_FALSE = "PAGE_LOADING_FALSE";

export const CURRENT_PAGE_SUCCESS = "CURRENT_PAGE_SUCCESS_STATE";

export const SHOW_SIDEBAR_ON_CURRENT_PAGE = "SIDEBAR_ON_CURRENT_PAGE";
export const DO_NOT_SHOW_SIDEBAR_ON_CURRENT_PAGE = "NO_SIDEBAR_ON_CURRENT_PAGE";

export const UPDATE_CHAT = "UPDATE_SINGLE_CHAT";

export const NEW_APPRAISAL = "NEW_SHOP_APPRAISAL";
export const OLD_APPRAIASAL = "OLD_SHOP_APPRAISAL";

export const CURRENT_TAB = "CURRENT_TAB_KEY";

export const REMOVE_APPRAISALS_DETAILS = "REMOVE_APPRAISALS_DETAILS_FROM_REDUX";

export const UPDATE_APPRAISAL_STATUS = "UPDATE_APPRAISAL_STATUS_FOR_REALTIME_CHANGE"

export const UPDATE_SORTING = "UPDATE_SORTING_ORDER"

export const ADD_CHAT_ID = "ADD_ACTION_CHAT_ID"